<template>
  <div class="card-header">
    <div class="card-header-top">
      <h2 class="card-title">{{ company['display-name'] }}</h2>

      <span
        v-if="plan.showPlan"
        :class="`partner-badge partner-badge--${plan.label.toLowerCase()}`"
      >
        {{ plan.label }}
      </span>
    </div>

    <div v-if="showReviews" class="card-header-bottom">
      <Review :review="company.review" />
    </div>
  </div>
</template>

<script>
import Review from 'chimera/all/page/thankYou/businessCard/partials/Review.vue'
import usesPartnerPlan from 'chimera/all/mixins/usesPartnerPlan'

export default {
  name: 'BusinessCardHeader',

  components: {
    Review,
  },

  mixins: [usesPartnerPlan],

  props: {
    company: {
      type: Object,
      required: true,
    },
  },

  computed: {
    /**
     * @returns {boolean}
     */
    showReviews() {
      if (this.company.review?.count <= 0 || this.company.review?.score <= 0) {
        return false
      }

      return this.plan.showReviews
    },

    /**
     * @returns {object}
     */
    plan() {
      return this.getPartnerPlan(this.company.plan)
    },
  },
}
</script>
